import { ExportOutlined } from "@ant-design/icons";
import { riskLink } from "@p0security/shared/assessment/render";
import { Risk } from "@p0security/shared/types/catalog";
import { Flex, Typography } from "@p0security/ui";
import { CatalogContext } from "components/Catalog/context";
import { GraphTooltip } from "components/GraphTooltip";
import { useContext } from "react";

import { Severity } from "../Severity";
import { LinkDetailsSpan, LinkNameSpan } from "./LinkDiv";

/** Renders a link to a single risk in the IAM Risk Catalog
 *
 * If the risk is remediated, renders struck through.
 */
export const RiskLink: React.FC<{
  risk: Pick<Risk, "id" | "name" | "score">;
}> = ({ risk }) => (
  <Flex align="center" gap="0.125em">
    {risk?.name ? (
      <>
        <GraphTooltip title={risk.name}>
          <LinkNameSpan>{risk?.name}</LinkNameSpan>
        </GraphTooltip>
        <LinkDetailsSpan>
          (<Severity severity={risk.score.toLocaleLowerCase()} />
          )&nbsp;
          <Typography.Link href={riskLink(risk)} target="catalog">
            <ExportOutlined />
          </Typography.Link>
        </LinkDetailsSpan>
      </>
    ) : (
      <>(No known risk)</>
    )}
  </Flex>
);

export const HydratedRiskLink: React.FC<{ id: string }> = ({ id }) => {
  const { risks } = useContext(CatalogContext);
  return id in risks ? <RiskLink risk={risks[id]} /> : <>{id}</>;
};
